var React = require('react');

function Ringv3 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#e4a86e;stroke-miterlimit:10;stroke-width:0.4px;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("circle",{"className":"cls-1","cx":"201.64","cy":"201.64","r":"201.44","key":0}),React.createElement("circle",{"className":"cls-1","cx":"252.28","cy":"249.27","r":"201.44","key":1}),React.createElement("circle",{"className":"cls-1","cx":"269.58","cy":"279.68","r":"201.44","key":2})]))]);
}

Ringv3.defaultProps = {"viewBox":"0 0 471.21 481.31"};

module.exports = Ringv3;

Ringv3.default = Ringv3;
